import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPanel = createCustomElementWrapper('kat-panel', 'KatPanel', {
    'disableAnimation': 'disable-animation',
    'katAriaLabel': 'kat-aria-label',
}, {
    'onClose': 'close',
    'onOpen': 'open',
}, [
    'header',
]);
